export default __webpack_public_path__ + "../images/preloader-logo.png";